import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import createDialog from './createDialog.vue';

var ProtocolLog = function (_super) {
  __extends(ProtocolLog, _super);

  function ProtocolLog() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.dataList = [];
    _this.columns = [];
    _this.loadingStatus = false;
    _this.searchData = _this.getInitSearchData();
    _this.lastParams = {};
    _this.total = 0;
    _this.codeTypeEnum = [];
    _this.statementTypeList = [];
    return _this;
  }

  ProtocolLog.prototype.created = function () {
    this.columns = [{
      title: this.t('用户账号'),
      dataIndex: 'login_account',
      filterEmpty: true
    }, {
      title: this.t('操作IP'),
      dataIndex: 'ip',
      filterEmpty: true
    }, {
      title: this.t('协议类型'),
      dataIndex: 'doc_type_text',
      filterEmpty: true
    }, {
      title: this.t('版本号'),
      dataIndex: 'doc_version',
      filterEmpty: true
    }, {
      title: this.t('状态'),
      dataIndex: 'status_text',
      filterEmpty: true
    }, {
      title: this.t('同意时间'),
      dataIndex: 'created_at',
      filterEmpty: true
    }, {
      title: this.t('操作'),
      dataIndex: 'operation',
      width: 80,
      fixed: 'right',
      scopedSlots: {
        customRender: 'operation'
      }
    }];
    this.queryProtocolLogList();
  };

  ProtocolLog.prototype.queryProtocolLogList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _i, _a, key, data, list, total;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            postData = {};

            for (_i = 0, _a = Object.keys(this.searchData); _i < _a.length; _i++) {
              key = _a[_i];
              postData[key] = this.searchData[key];
            }

            this.lastParams = this.$util.deepCopy(postData);
            return [4, this.$api.user.queryProtocolLogList(postData)];

          case 1:
            data = _b.sent().data;
            list = data.list, total = data.total;
            this.dataList = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  ProtocolLog.prototype.getInitSearchData = function () {
    return {
      code_type: this.$enum.common.AgreementLogTypeEnum.USER_CODE,
      code_value: undefined,
      type: undefined,
      version: undefined,
      page_index: 1,
      page_size: 10
    };
  };

  ProtocolLog.prototype.handleAdd = function () {
    var create = this.$refs.createRef;
    console.log('create =>', create);
    create.visible = true;
  };

  ProtocolLog.prototype.handlePageChange = function (page) {
    this.searchData.page_index = page;
    this.queryProtocolLogList();
  };

  ProtocolLog.prototype.initPage = function () {
    this.searchData.page_index = 1;
  };

  ProtocolLog.prototype.handleSearch = function () {
    this.initPage();
    this.queryProtocolLogList();
  };

  ProtocolLog.prototype.handleReset = function () {
    var _this = this;

    this.searchData = this.getInitSearchData();
    this.initPage();
    this.$nextTick(function () {
      return _this.queryProtocolLogList();
    });
  };

  __decorate([enumData('AgreementLogTypeEnum')], ProtocolLog.prototype, "codeTypeEnum", void 0);

  __decorate([enumData('StatementTypeEnum')], ProtocolLog.prototype, "statementTypeList", void 0);

  __decorate([loading('loadingStatus')], ProtocolLog.prototype, "queryProtocolLogList", null);

  __decorate([userPrefPageSize('protocolLogList')], ProtocolLog.prototype, "getInitSearchData", null);

  ProtocolLog = __decorate([Component({
    components: {
      createDialog: createDialog
    }
  })], ProtocolLog);
  return ProtocolLog;
}(Vue);

export default ProtocolLog;